import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import BlankModal from './BlankModal';
import IssueCredDetails from '../components/modals/IssueCredDetails';
import { IUser } from '../types/user';
import { useCredentialContext, useTenantContext, useToastContext } from '../contexts';

export interface SendUserCredModalProps {
  isVisible: boolean;
  onClose: () => void;
  user: IUser;
}

/**
 * SendUserCredModal component
 *
 * @param {*} {
 *   isVisible,
 *   onClose,
 *   user
 * }
 * @return {*}
 */
const SendUserCredModal: React.FC<SendUserCredModalProps> = ({ isVisible, onClose, user }) => {
  const credentialContext = useCredentialContext();
  const tenantContext = useTenantContext();
  const toast = useToastContext();

  const sendCredential = async (data: IUser) => {
    credentialContext.sendCredential(data);
    credentialContext.setSchema(null);
    toast.showToast('Credential sent successfully', 3000);
    onClose();
  };

  const onValueChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    const schema =
      tenantContext.schemas?.find((schema) => schema.schema.name === selectedValue) || null;
    credentialContext.setSchema(schema);
  };

  const handleClose = () => {
    onClose();
    credentialContext.setSchema(null);
  };

  return (
    <BlankModal
      title="Issue credential"
      isVisible={isVisible}
      onClose={handleClose}
      onConfirm={() => sendCredential(user)}
      acceptText="Issue credential"
      isLoading={credentialContext.loading}
      isDisabled={credentialContext.schema === null}>
      <View style={styles.container}>
        <View style={styles.formSection}>
          <Text style={styles.label}>Credential Schema</Text>
          <select
            style={styles.select}
            value={credentialContext.schema?.schema.name || ''}
            onChange={onValueChange}>
            <option value="" disabled>
              Select a Credential Schema
            </option>
            {tenantContext.schemas?.map((schema, index) => (
              <option key={index} value={schema.schema.name}>
                {schema.schema.name}
              </option>
            ))}
          </select>
        </View>

        {credentialContext.attributes.length > 0 && (
          <IssueCredDetails
            user={user}
            attributes={credentialContext.attributes}
            name={credentialContext.name}
          />
        )}
      </View>
    </BlankModal>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1
  },
  formSection: {
    marginBottom: 20
  },
  label: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1a1a1a',
    marginBottom: 8
  },
  select: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    padding: 10,
    fontSize: 14,
    color: '#000',
    backgroundColor: '#fff',
    width: '100%',
    minHeight: 40,
    cursor: 'pointer'
  }
});

export default SendUserCredModal;
